export const API_BASE_ADDRESS = process.env.API_BASE_ADDRESS;
export const AUDIENCE_STUDIO_API_ENDPOINT = `${API_BASE_ADDRESS}/audience-studio`;
